import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rendicioncuentas',
  templateUrl: './rendicioncuentas.component.html',
  styleUrls: ['./rendicioncuentas.component.css']
})
export class RendicioncuentasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
